import { render, staticRenderFns } from "./Profil.vue?vue&type=template&id=76cd5a1e&scoped=true&"
import script from "./Profil.vue?vue&type=script&lang=ts&"
export * from "./Profil.vue?vue&type=script&lang=ts&"
import style0 from "./Profil.vue?vue&type=style&index=0&id=76cd5a1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cd5a1e",
  null
  
)

export default component.exports